/** Tokens rítmicos canónicos — contrato entre LLM, backend y renderizadores. */

export type MusicalToken = 'W' | 'H' | 'Q' | 'E' | 'S' | 'R_W' | 'R_H' | 'R_Q' | 'R_E' | 'R_S';

export type TimeSignature = '4/4' | '3/4' | '2/4';

/** Método de lectura elegido por el docente (no impuesto por la app). */
export type RhythmReadingMethod = 'tradicional' | 'takadimi' | 'kodaly';

/** Modo de soporte gráfico en impresión / UI. */
export type MusicGraphicMode = 'symbols' | 'symbols-labels';

export interface RhythmicPatternPayload {
  timeSignature: TimeSignature;
  /** Secuencia estricta de tokens — ej. ['Q', 'E', 'Q', 'R_Q'] */
  pattern: MusicalToken[];
  /** Índice del hueco en completar / dictado (opcional). */
  missingIndex?: number;
}

export interface MusicGenerationPrefs {
  readingMethod: RhythmReadingMethod;
  graphicMode: MusicGraphicMode;
}

export const DEFAULT_MUSIC_PREFS: MusicGenerationPrefs = {
  readingMethod: 'tradicional',
  graphicMode: 'symbols',
};

export const MUSICAL_TOKENS: MusicalToken[] = ['W', 'H', 'Q', 'E', 'S', 'R_W', 'R_H', 'R_Q', 'R_E', 'R_S'];
